import { css } from '@emotion/react';
import { theme } from 'global';

export const setupList = css`
  margin: 0;
  padding: 0 0 0 20px;
`;

export const tooltipWrapper = css`
  display: inline-flex;
  text-decoration: underline;
  cursor: pointer;
`;

export const zipBusinessCheckbox = css`
  margin-top: 16px;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    margin-top: 32px;
  }
`;
